"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var Lockr = __importStar(require("lockr"));
var ui_components_2 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_3 = require("@l2p/ui-components");
var apps_shared_2 = require("@l2p/apps-shared");
var navigation_1 = require("next/navigation");
var swr_hooks_1 = require("@l2p/swr-hooks");
var useCurrentBonusToOpen_1 = require("./useCurrentBonusToOpen");
var CashBonusPopup = function () {
    var _a, _b;
    var t = (0, next_intl_1.useTranslations)('translation');
    var router = (0, navigation_1.useRouter)();
    var _c = (0, swr_hooks_1.useCancelBonus)({
        successAction: router.refresh,
    }), cancelBonus = _c.cancelBonus, isSubmitting = _c.isSubmitting;
    var closeModal = (0, apps_shared_2.useCloseModal)();
    var popupWasShownData = (0, react_1.useMemo)(function () {
        if (typeof window !== 'undefined')
            return Lockr.get(apps_shared_1.POPUP_CONSTANTS.CASH_BONUS) || {};
        return {};
    }, []);
    var currentBonus = (0, useCurrentBonusToOpen_1.useCurrentBonusToOpen)();
    var closeModalHandler = (0, react_1.useCallback)(function () {
        var _a;
        if (typeof window !== 'undefined' && (currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.id))
            Lockr.set(apps_shared_1.POPUP_CONSTANTS.CASH_BONUS, __assign(__assign({}, popupWasShownData), (_a = {}, _a[currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.id] = true, _a)));
        closeModal();
        router.refresh();
    }, [router, closeModal, currentBonus, popupWasShownData]);
    var onCancelHandler = (0, react_1.useCallback)(function () {
        if (!(currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.id))
            return;
        cancelBonus({ bonusId: currentBonus.id });
        closeModalHandler();
    }, [closeModalHandler, currentBonus, cancelBonus]);
    if (!(currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.id))
        return null;
    return (react_1.default.createElement(ui_components_1.Modal, { portalNodeId: "modal", width: "460px", onClose: closeModalHandler },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('youGotCashBonus')),
            (currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.currency) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.bet }, "".concat(t('amount'), ": ").concat((0, apps_shared_2.getCurrencySymbol)(currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.currency), " ").concat(Number((currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.balance) || 0).toFixed(2)))),
            ((_a = currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.bonus) === null || _a === void 0 ? void 0 : _a.wageringMultiplier) ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.description },
                t('wager'),
                ": ", "".concat((_b = currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.bonus) === null || _b === void 0 ? void 0 : _b.wageringMultiplier, "x"))) : null,
            react_1.default.createElement("img", { className: styles_module_scss_1.default.image, src: "/img/cash-bonus-icon.svg", alt: "cash" }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                react_1.default.createElement(ui_components_2.FixedButton, { color: "gradient", text: "upper", width: "100%", maxWidth: "200px", onClick: closeModalHandler }, t('ok')),
                react_1.default.createElement(ui_components_3.GradientOutlinedButton, { text: "upper", onClick: onCancelHandler, loading: isSubmitting }, t('cancel'))),
            react_1.default.createElement("br", null))));
};
exports.default = CashBonusPopup;
